// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function … --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeStringFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useWebHardLoginGateVariation = makeStringFlagValueHook('web-hard-login-gate');
//# sourceMappingURL=useWebHardLoginGateVariation.js.map